module.exports = __webpack_public_path__ + "./assets/img_zhongshan_grey@2x__cefe1f2120d996caa0bdff1e9935a690.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/home/img_zhongshan_grey@2x.jpg
// module id = 638
// module chunks = 12